import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  colors,
  Container,
  Hidden,
  Paper,
  Typography,
} from "@material-ui/core";
import fontConfig from "../../constants/fonts";
import FancyButton from "../Common/Buttons/FancyButton";
import LayoutContainer from "../LayoutsContainer";
import { getImageUrl } from "../../redux/types";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    // backgroundColor: "red",
    display: "flex",
    justifyContent: "center",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      padding: 0,
      width: "100vw",
      paddingBottom: 0,
    },
  },
  Container: {
    height: "50vh",
    backgroundColor: "transparent",
    // display: "flex",
    // alignItems: "flex-end",
    position: "relative",
    width: "100%",
    // backgroundColor: "green",
    zIndex: 10,
    [theme.breakpoints.down("md")]: {
      height: "25vh",
      // backgroundColor: "red",
    },
  },
  bgContainer: {
    position: "absolute",
    top: "10vh",
    zIndex: 1,

    height: "40vh",
    // backgroundColor: "white",
    backgroundColor: "#f8e9cf",
    boxShadow: "7px 7px 14px #dcdcdc, -7px -7px 14px rgba(255,255,255,0.5);",

    width: "100%",
    borderRadius: 30,
    flex: 1,
    [theme.breakpoints.down("md")]: {
      borderRadius: 20,
      // backgroundColor: "red",

      height: "20vh",
      top: "5vh",
      width: "92vw",
    },
  },
  mainContainer: {
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "absolute",

    zIndex: 1,
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "green",
    },
  },
  imgContainer: {
    height: "50vh",
    // backgroundColor: "green",
    width: "100%",
    flex: 1,
    [theme.breakpoints.down("md")]: {
      height: "25vh",
      width: "30vw",
    },
  },
  titleContainer: {
    flex: 3,
    // margin: "5vh",
    paddingTop: 60,
    paddingRight: "10vw",
    [theme.breakpoints.down("md")]: {
      paddingTop: "5vh",
      paddingRight: "2vw",
    },
    // backgroundColor: "red",
  },
  BtnContainer: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(1),
    },
  },
  title: {
    ...fontConfig.medium,
    fontSize: "2rem",
    [theme.breakpoints.down("md")]: {
      ...fontConfig.medium,
      fontSize: "0.8rem",
    },
    // color: "red",
  },
  img: {
    height: "50vh",
    [theme.breakpoints.down("md")]: {
      height: "25vh",
      // width: "30vw",
    },
  },
}));

const CarouselItem = ({ data }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <LayoutContainer>
        <Paper className={classes.Container} elevation={0}>
          <div className={classes.bgContainer}></div>
          <div className={classes.mainContainer}>
            <div className={classes.imgContainer}>
              <img src={getImageUrl(data.image)} className={classes.img} />
            </div>

            <div className={classes.titleContainer}>
              <Typography className={classes.title}>{data.title}</Typography>

              {/* <Hidden mdDown>
                <div className={classes.BtnContainer}>
                  <FancyButton>Learn more</FancyButton>
                </div>
              </Hidden> */}
            </div>
          </div>

          {/* <div className={classes.imgContainer}>
            <div className={classes.titleContainer}>
              <Typography className={classes.title}>{data.title}</Typography>
            </div>
          </div> */}
        </Paper>
      </LayoutContainer>
    </div>
  );
};
export default CarouselItem;
